import type { AgentStudioAssistant, AgentStudioServiceAgent } from '../../types/entity-nodes';

export type { AgentStudioAssistant, AgentStudioServiceAgent } from '../../types/entity-nodes';

type RovoAgentEntity = AgentStudioAssistant | AgentStudioServiceAgent;

const ROVO_AGENT_ARI_PATTERN = /^ari:cloud:rovo:[^:]*:agent\/activation\/[^/]+\/([^/?#]+)$/;

const getRovoAgentId = (id: string | undefined): string | null => {
	if (!id) {
		return null;
	}

	const ariMatch = id.match(ROVO_AGENT_ARI_PATTERN);
	if (ariMatch?.[1]) {
		return ariMatch[1];
	}

	if (/^[\w-]+$/.test(id)) {
		return id;
	}

	return null;
};

export const isAgentStudioAssistant = (entity: any): entity is AgentStudioAssistant =>
	entity.__typename === 'AgentStudioAssistant';

export const isAgentStudioServiceAgent = (entity: any): entity is AgentStudioServiceAgent =>
	entity.__typename === 'AgentStudioServiceAgent';

export const getRovoAgentLink = (
	agent: RovoAgentEntity,
	orgHomeUrl: string,
	cloudId: string,
): string | null => {
	const agentId = getRovoAgentId(agent.id);
	if (!agentId) {
		return null;
	}

	return `${orgHomeUrl}/people/agent/${agentId}?cloudId=${cloudId}`;
};
